// extracted by mini-css-extract-plugin
module.exports = {"outer":"failure_outer__GGNrt","inner":"failure_inner__Dus4b"};